import { extract } from '@/backends/editor'

export const commentText = (comment) => {
  switch (comment.content_type) {
  case 'editor_js': return extract.title(JSON.parse(comment.comment))
  case 'raw_text': return comment.comment
  default: return comment.comment
  }
}